import React, { useEffect, useState } from 'react';
import '../styles/landing-override.css';

const ensureLink = (href, rel = 'stylesheet', extra = {}) => {
  if (document.querySelector(`link[href="${href}"]`)) return Promise.resolve();
  
  return new Promise((resolve) => {
    const link = document.createElement('link');
    link.rel = rel;
    link.href = href;
    link.onload = resolve;
    link.onerror = resolve; // Still resolve even on error
    Object.entries(extra).forEach(([k, v]) => (link[k] = v));
    document.head.appendChild(link);
  });
};

const ensureScript = (src) => {
  return new Promise((resolve) => {
    if (window.Flickity || document.querySelector(`script[src="${src}"]`)) {
      resolve();
      return;
    }
    const s = document.createElement('script');
    s.src = src;
    s.async = true;
    s.onload = resolve;
    s.onerror = resolve; // Still resolve even on error
    document.body.appendChild(s);
  });
};

const Layout = ({ children }) => {
  const [scriptsLoaded, setScriptsLoaded] = useState(false);

  useEffect(() => {
    document.documentElement.setAttribute('dir', 'rtl');
    document.documentElement.lang = 'fa';
    document.body.dataset.globalFooter = '1';

    // Load all resources and wait for scripts
    const loadAssets = async () => {
      await Promise.all([
        ensureLink('/landing/uploads/mimt/assets/fonts/Pinar-VF-FD.woff2', 'preload', { as: 'font', type: 'font/woff2', crossOrigin: 'anonymous' }),
        ensureLink('/landing/uploads/mimt/assets/fonts/niafam-icons.woff', 'preload', { as: 'font', type: 'font/woff', crossOrigin: 'anonymous' }),
        ensureLink('/landing/uploads/mimt/assets/css/bootstrap-grid.css'),
        ensureLink('/landing/uploads/mimt/assets/css/mmenu.css'),
        ensureLink('/landing/uploads/mimt/assets/css/flickity.css'),
        ensureLink('/landing/uploads/mimt/assets/css/sm-core-css.css'),
        ensureLink('/landing/uploads/mimt/assets/css/sm-simple.css'),
        ensureLink('/landing/uploads/mimt/assets/css/assistants.css'),
        ensureLink('/landing/uploads/mimt/assets/css/lightgallery.min.css'),
        ensureLink('/landing/uploads/mimt/assets/css/my-style.css'),
      ]);

      // // Load scripts sequentially (jQuery first, then Flickity)
      // await ensureScript('https://code.jquery.com/jquery-3.6.0.min.js');
      // await ensureScript('https://cdnjs.cloudflare.com/ajax/libs/flickity/2.3.0/flickity.pkgd.min.js');
      
      await ensureScript('/landing/uploads/mimt/assets/js/jquery.min.js');
      await ensureScript('/landing/uploads/mimt/assets/js/flickity.pkgd.min.js');
      
      setScriptsLoaded(true);
    };

    loadAssets();
  }, []);

  return scriptsLoaded ? <>{children}</> : <div>Loading...</div>;
};

export default Layout;